export const Validators = [
    {
        name: 'NEO',
        regexp: '^[0-9]{1}[0-9]{0,11}$',
        numberOfDigits: 12
    },
    {
        name: 'PHONE',
        regexp: '^[1-9]{1}[0-9]{0,8}$',
        numberOfDigits: 9
    },
    {
        name: 'PIN',
        regexp: '^[0-9]{0,${NOD}}$'
    },
    {
        name: 'EMAIL',
        regexp: '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,})+$'
    },
    {
        name: 'NIP',
        regexp: '^[1-9]{1}[0-9]{0,9}$',
        numberOfDigits: 10
    },
    {
        name: 'PESEL',
        regexp: '^[1-9]{1}[0-9]{0,10}$',
        numberOfDigits: 11
    }
];

export const getValidator = name => {
    if (!name) {
        return null;
    }

    let validator = null;
    name = name.toUpperCase();

    Validators.forEach(v => {
        if (v.name === name.replace(/\d+/g, '')) {
            validator = v;
        }
    });

    if (validator && validator.name === 'PIN') {
        const numberOfDigits = name.replace('PIN', '');
        validator = {
            ...validator,
            regexp: validator.regexp.replace('${NOD}', numberOfDigits),
            numberOfDigits: parseInt(numberOfDigits)
        };
    }

    return validator;
};

export const validate = (type, value) => {
    const validator = getValidator(type);

    if (!validator) {
        return { isValueValid: true, isLengthValid: true };
    }

    if (value.length === 0) {
        return { isValueValid: true, isLengthValid: false };
    }

    let isValueValid = false;
    let isLengthValid = false;

    if (value.match(new RegExp(validator.regexp))) {
        isValueValid = true;

        if (!validator.numberOfDigits) {
            isLengthValid = true;
        }
    }

    if (validator.numberOfDigits && value.length >= validator.numberOfDigits) {
        isLengthValid = true;
    }

    return { isValueValid, isLengthValid };
};
